module.exports = __webpack_public_path__ + "img/Niger.fa14b937.png";